import { Box, Text } from "@chakra-ui/react";
import { getRelativeDate } from "../common/utils";
import { useNavigate } from "react-router-dom";
import { Item } from "../api/client";

export const ArticleCard = ({ articleData }: { articleData: Item }) => {
  const navigate = useNavigate();
  return (
    <Box
      data-testid="article-card"
      borderWidth="1px"
      boxShadow="xl"
      borderColor="hn.background_dark"
      overflow="hidden"
      margin="2"
    >
      <Box display="flex" p="6">
        <Box>
          <Box
            as="button"
            mb="3"
            fontWeight="bold"
            letterSpacing="wide"
            lineHeight="tight"
            fontSize="lg"
            color="hn.off_white"
            onClick={() => {
              navigate(`/article/${articleData.id}`);
            }}
          >
            <Box as="h2" _hover={{ color: "hn.highlight" }}>
              {articleData.title}
            </Box>
          </Box>

          <Box>
            {articleData.score} points | {articleData.descendants} comments |
            by&nbsp;
            <Text as="span" color="hn.off_white" fontWeight="bold">
              {articleData.by}&nbsp;
            </Text>
            <Text as="span" color="hn.grey" fontWeight="bold">
              {getRelativeDate(articleData.time)}
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
